import type { MatrixType, ProductGender, TargetedAssortmentEnum } from '@onrunning/backstage-models';

import type { MatrixProduct } from '@/models/matrix-product.model';
import type { ProductSize } from '@/models/product-size.model';
import type { ProductsSizeGroupsModel } from '@/models/products-size-groups.model';
import type { MatrixOrderProduct } from '@/types/product.interface';
import type { Warehouse } from '@/types/warehouse.interface';
import type { FabricDisabledReason } from './matrix.enums';

export interface ProductMatrixApiResponse {
  warehouse: Warehouse;
  products: MatrixProduct[];
  sizeGroups: ProductsSizeGroupsModel[];
}

export interface Fabric {
  id: string;
  name: string;
  imageUrl: string;
  disabled: boolean;
  launchDate: string;
  description: string;
  preOrderEarliestRequestedDate?: string;
  products: Record<string, MatrixProduct>;
  disabledReason: FabricDisabledReason | null;
  targetedAssortments?: TargetedAssortmentEnum[];
}

export interface ProductGroup {
  id: string;
  name: string;
  sizes: Map<string, ProductSize>;
  fabrics: Map<string, Fabric>;
}

export interface GroupedMatrix {
  id: string;
  name: ProductGender;
  productGroups: Map<string, ProductGroup>;
}

export interface MatrixConfig {
  orderDate?: string;
  matrixType?: MatrixType;
  seasonStart?: string;
  isExistingOrder?: boolean;
  orderNumber?: string;
  selectedProductModelNames?: string[];
}

export interface MatrixTotals {
  matrixTotal: number;
  fabricTotals: Record<string, number>;
  productTotals: Record<string, number>;
  productGroupTotals: Record<string, number>;
  mainGroupTotals: Record<string, number>;
  groupGenderTotals: Record<string, number>;
}

export interface ProductModelDetails {
  name: string;
  selected?: boolean;
  defaultImage: string;
  defaultVariantImages: string[];
}

export interface MatrixOrder {
  orderId?: string;
  orderNumber?: string;
  date: Date;
  matrixProducts: Record<string, MatrixOrderProduct>;
  total: number;
}

export enum ProductMatrixGroupByOptions {
  Model = 'Model',
  ShippingDate = 'Shipping date',
}
